(function () {
  'use strict';

  var initialized = new WeakSet();

  function whenVisible(element, callback, rootMargin) {
    if (!element || typeof callback !== 'function' || initialized.has(element)) return;
    initialized.add(element);

    if (!('IntersectionObserver' in window) || window.Shopify && window.Shopify.designMode) {
      callback();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      observer.disconnect();
      callback();
    }, { rootMargin: rootMargin || '240px 0px' });

    observer.observe(element);
  }

  function eligibleLink(anchor) {
    if (!anchor || anchor.origin !== location.origin || anchor.hasAttribute('download')) return false;
    if (anchor.target && anchor.target !== '_self') return false;
    return /^\/(products|collections)(\/|$)/.test(anchor.pathname);
  }

  function prefetch(anchor) {
    if (!eligibleLink(anchor) || anchor.dataset.lkzPrefetched === 'true') return;
    anchor.dataset.lkzPrefetched = 'true';
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = anchor.href;
    link.as = 'document';
    document.head.appendChild(link);
  }

  function optimizeImage(image) {
    if (!image || image.closest('.lkz-luxury-hero')) return;
    image.loading = 'lazy';
    image.decoding = 'async';
    if (image.getAttribute('fetchpriority') === 'high') image.removeAttribute('fetchpriority');
  }

  document.querySelectorAll('img').forEach(optimizeImage);

  document.addEventListener('mouseover', function (event) {
    var anchor = event.target.closest && event.target.closest('a[href]');
    if (anchor) prefetch(anchor);
  }, { passive: true });

  document.addEventListener('touchstart', function (event) {
    var anchor = event.target.closest && event.target.closest('a[href]');
    if (anchor) prefetch(anchor);
  }, { passive: true });

  window.LukzerPerformance = { whenVisible: whenVisible };
})();
